"use client";
import { SUPPORT_EMAIL } from "@/lib/constants";
import { Copy } from "lucide-react";
import { toast } from "sonner";

export function SupportClipboard() {
  return (
    <p className="text-center text-sm text-balance text-slate-900">
      Need help or support? <br />
      Reach out at{" "}
      <span className="text-slate-500 underline">{SUPPORT_EMAIL}</span>
      <button
        onClick={() => {
          navigator.clipboard.writeText(SUPPORT_EMAIL);
          toast.info("Support email copied to clipboard");
        }}
      >
        <Copy className="ml-1 inline-block size-4 cursor-pointer text-slate-500" />
      </button>
    </p>
  );
}
